import { Helmet } from "react-helmet";
import PortfoliosEditSection from "./PortfoliosEditSection";
import Navbar from "components/Navbar";


export default function Portfolios() {
  return (
    <>
      <Helmet>
        <title>Portfolio Management - Edit and Analyze Your Investments</title>
        <meta
          name="description"
          content="Efficiently manage and edit your investment portfolios. Access risk models, performance reports, and dashboards for insightful financial analysis."
        />
      </Helmet>
      <div className="w-full">
        <div className="relative h-[1000px] content-end bg-gray-900_01 md:h-auto">
          <div className="absolute left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[108px] md:gap-[81px] sm:gap-[54px]">
              <div className="container-xs md:px-5">
                <Navbar />
              </div>
            </div>  
            
            <div className="flex mt-20 h-max flex-1 flex-col items-center gap-[52px] py-6 sm:gap-[26px] sm:py-5">
              {/* portfolios edit section */}
              <PortfoliosEditSection />
            </div> 
        </div>
      </div>
    </>
  );
}
